import { useEffect, useRef } from 'react'

import { REFRESCO_HILO_ABIERTO_MS, tocaRefrescarHilo } from './refresco-hilo'

/** Mientras este componente está montado, la conversación se vuelve a pedir. */
export function useRefrescoHiloAbierto(recargar: () => void) {
    const recargarRef = useRef(recargar)
    recargarRef.current = recargar

    useEffect(() => {
        const id = window.setInterval(() => {
            if (!tocaRefrescarHilo(true, document.hidden)) return
            recargarRef.current()
        }, REFRESCO_HILO_ABIERTO_MS)
        return () => window.clearInterval(id)
    }, [])
}
